module.exports = __webpack_public_path__ + "img/failed.ae9bb98b.gif";